﻿import { onLoad } from 'runtime';

onLoad(context => {
    context.querySelectorAll(".google-review-carousel").forEach(carousel => {
        const btnLeft = carousel.querySelector("[id^=scroll-left]");
        const btnRight = carousel.querySelector("[id^=scroll-right]");
        const scrollableArea = carousel.querySelector(".overflow-auto");
        const reviews = carousel.querySelectorAll(".card");
        const motionQuery = window.matchMedia("(prefers-reduced-motion: reduce)");
        let isReducedMotion = motionQuery.matches;

        let snapPointsSavedAtColumn = null;
        let snapPoints = [];
        let maxScroll = scrollableArea.scrollWidth - scrollableArea.clientWidth;

        function calculateSnapPoints() {
            const computedStyle = getComputedStyle(scrollableArea);
            const columnAmount = parseInt(computedStyle.getPropertyValue("--column-amount"));

            if (columnAmount === snapPointsSavedAtColumn) return;
    
            snapPoints = [];
            maxScroll = scrollableArea.scrollWidth - scrollableArea.clientWidth;
    
            reviews.forEach(cell => {
                snapPoints.push(Math.min(cell.offsetLeft, maxScroll));
            });

            snapPointsSavedAtColumn = columnAmount;
        }

        new ResizeObserver(calculateSnapPoints).observe(scrollableArea);

        function scrollCarousel(isRight = true) {
            const currentScroll = scrollableArea.scrollLeft;
            let targetScroll = null;

            if (isRight) targetScroll = snapPoints.find(p => p > currentScroll + 1) ?? 0;
            else targetScroll = snapPoints.findLast(p => p < currentScroll - 1) ?? maxScroll;

            const finalDestination = Math.min(targetScroll, maxScroll);

            scrollableArea.scrollTo({
                left: finalDestination,
                behavior: isReducedMotion ? "instant" : "smooth"
            });
        }

        btnLeft.addEventListener("click", () => scrollCarousel(false));
        btnRight.addEventListener("click", () => scrollCarousel(true));
    
        let isHovered = false;
        let isFocused = false;
        let isOnScreen = false;

        let intervalId = null;
        function autoScrollCheck() {
            if (isOnScreen && !isHovered && !isFocused && !isReducedMotion) {
                if (intervalId !== null) return;
                
                intervalId = setInterval(scrollCarousel, 2_500);
                return;
            }

            if (intervalId === null) return;
            clearInterval(intervalId);
            intervalId = null;
        }

        new IntersectionObserver((entries) => {
            isOnScreen = entries[0].isIntersecting;
            autoScrollCheck();
        }, { threshold: 0.1 }).observe(carousel);

        carousel.addEventListener("mouseenter", () => {
            isHovered = true;
            autoScrollCheck();
        });
        carousel.addEventListener("mouseleave", () => {
            isHovered = false;
            autoScrollCheck();
        });
        carousel.addEventListener("focusin", () => {
            isFocused = true;
            autoScrollCheck();
        });
        carousel.addEventListener("focusout", () => {
            isFocused = false;
            autoScrollCheck();
        });
        motionQuery.addEventListener("change", (e) => {
            isReducedMotion = e.matches;
            autoScrollCheck();
        });

        autoScrollCheck();
    });
});